import { createSlice } from "@reduxjs/toolkit";
import { BaseApiState } from "../../../api/axiosConfig";
import { handlePending, handleReject } from "../../../utils/redux";
import {
  fetchExaminationCard,
  submitExaminationCard,
  updateExaminationCardWithDefaultExaminationCourse,
  downloadExaminationCard,
} from "../../actions/documentation/examinationCardActions";
import { ExaminationCard } from "../../../api/documents/examinationCardApi";

interface JudgementSlice extends BaseApiState {
  document?: ExaminationCard;
}

const initialState: JudgementSlice = {
  document: undefined,
  succeeded: false,
  loading: false,
  error: false,
  errorMessage: undefined,
  errorDetails: undefined,
};

const ExaminationCardSlice = createSlice({
  name: "ExaminationCardSlice",
  initialState,
  reducers: {
    resetExaminationCardData(state) {
      state.document = undefined;
    },
    updateExaminationExtendedResultsList(state, action) {
      if (state.document) {
        // Aktualizuj extended results jeśli są w payload
        if (action.payload.examinationExtendedResultsList !== undefined) {
          state.document.examinationExtendedResultsList =
            action.payload.examinationExtendedResultsList;
        }

        // Aktualizuj zwykłe results jeśli są w payload
        if (action.payload.examinationResultsList !== undefined) {
          state.document.examinationResultsList =
            action.payload.examinationResultsList;
        }
      }
    },
    updateSelectedExaminationAimList(state, action) {
      if (state.document) {
        if (!state.document.examinationAim) {
          state.document.examinationAim = [];
        }
        state.document.examinationAim = action.payload.userValue;
      }

      if (action.payload.indexArray.length > 0) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-call
        action.payload.indexArray.forEach((element: number) => {
          if (state.document && state.document.judgment.judgment) {
            switch (element) {
            case 0:
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              (
                  state.document.judgment.judgment as any
              ).drivingVehiclesContraindication = "false";
              break;
            case 1:
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              (
                  state.document.judgment.judgment as any
              ).professionalDriverContraindication = "false";
              break;
            case 2:
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              (
                  state.document.judgment.judgment as any
              ).emergencyVehicleDriverContraindication = "false";
              break;
            case 3:
              // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
              (
                  state.document.judgment.judgment as any
              ).drivingInstructorContraindication = "false";
              break;
            }
          }
        });
      }
    },
    updateSelectedExaminationDrivingCategoriesList(state, action) {
      if (state.document && state.document.drivingLicense) {
        state.document.drivingLicense = action.payload;
      }
    },
    updateSelectedT2DJugmnetList(state, action) {
      if (state.document && state.document.judgment.judgment) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (
          state.document.judgment.judgment as any
        ).drivingVehiclesContraindication =
          action.payload[0].checked || "false";
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (
          state.document.judgment.judgment as any
        ).professionalDriverContraindication =
          action.payload[1].checked || "false";
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (
          state.document.judgment.judgment as any
        ).emergencyVehicleDriverContraindication =
          action.payload[2].checked || "false";
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        (
          state.document.judgment.judgment as any
        ).drivingInstructorContraindication =
          action.payload[3].checked || "false";
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExaminationCard.pending, handlePending)
      .addCase(fetchExaminationCard.rejected, handleReject)
      .addCase(fetchExaminationCard.fulfilled, (state, action) => {
        if (
          action.payload.results.judgment.judgment === null &&
          action.payload.results.methodology === "TEST2DRIVE"
        ) {
          action.payload.results.judgment.judgment = {
            drivingVehiclesContraindication: false,
            professionalDriverContraindication: false,
            emergencyVehicleDriverContraindication: false,
            drivingInstructorContraindication: false,
          };
        }
        state.document = action.payload.results;
        state.loading = false;
        state.succeeded = true;
      })
      .addCase(submitExaminationCard.pending, handlePending)
      .addCase(submitExaminationCard.rejected, handleReject)
      .addCase(submitExaminationCard.fulfilled, (state, action) => {
        state.document = action.payload.results;
        state.loading = false;
        state.succeeded = true;
      })
      .addCase(
        updateExaminationCardWithDefaultExaminationCourse.pending,
        handlePending
      )
      .addCase(
        updateExaminationCardWithDefaultExaminationCourse.rejected,
        handleReject
      )
      .addCase(
        updateExaminationCardWithDefaultExaminationCourse.fulfilled,
        (state, action) => {
          state.document = action.payload.results;
          state.loading = false;
          state.succeeded = true;
        }
      )
      .addCase(downloadExaminationCard.pending, handlePending)
      .addCase(downloadExaminationCard.rejected, handleReject)
      .addCase(downloadExaminationCard.fulfilled, (state) => {
        state.loading = false;
        state.succeeded = true;
      });
  },
});

export const ExaminationCardReducer = ExaminationCardSlice.reducer;
export const {
  resetExaminationCardData,
  updateExaminationExtendedResultsList,
  updateSelectedExaminationAimList,
  updateSelectedExaminationDrivingCategoriesList,
  updateSelectedT2DJugmnetList,
} = ExaminationCardSlice.actions;